const UserPasswordType = Symbol();

// パスワードの最低長
export const PasswordMinLength = 12;

export class UserPassword {
    [UserPasswordType]: any;
    readonly value: string;

    private constructor(password: string) {
        this.value = password;
    }

    static fromString(password: string): UserPassword {
        return new UserPassword(password);
    }

    static fromNothing(): UserPassword {
        return new UserPassword("");
    }

    // パスワードの最低長チェック
    isValidLength(): boolean {
        return !(this.value.length < PasswordMinLength);
    }

    // 確認用パスワードのチェック
    isConfirmOk(confirmPasswordValue: string): Boolean {
        return this.value === confirmPasswordValue;
    }
}
